import { render } from "./PdfChip.vue?vue&type=template&id=f6e4c6ee&scoped=true&ts=true"
import script from "./PdfChip.vue?vue&type=script&lang=ts"
export * from "./PdfChip.vue?vue&type=script&lang=ts"

import "./PdfChip.vue?vue&type=style&index=0&id=f6e4c6ee&scoped=true&lang=scss"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6e4c6ee"]])

export default __exports__